import { ButtonV2Props } from '../../components/ButtonV2';
import { textTitle3 } from '../../../../growth-platform-brand-system-v2/src/styles/typography';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';
import React, { FC, ReactElement } from 'react';
import { Tag, TagProps } from '../Tag';
import { Image } from '../Image';
import { ImageProps } from '../Image/types';

export interface BlogStickyBannerProps {
  title?: string;
  image?: ImageProps;
  cta: ReactElement<ButtonV2Props>;
  className?: string;
  titleClassName?: string;
  tags?: TagProps[];
}

export const BlogStickyBanner: FC<BlogStickyBannerProps> = ({
  title,
  image,
  cta,
  className,
  titleClassName,
  tags,
}) => {
  return (
    <div
      className={classNames(
        'BlogStickyBanner',
        'md:rounded-[18px] lg:rounded-12 banner-stick',
        'bg-blue-21 block md:inline-block w-full lg:w-auto',
        className,
      )}
    >
      {image && (
        <div className="image-container w-full rounded-t-12 rounded-b-none overflow-hidden hidden lg:block">
          <Image
            loading="lazy"
            src={image.url}
            alt={image.alt || 'Banner Image'}
            width={image.width}
            height={image.height}
            sizes={['384px']}
            className="rounded-12 w-full image-container"
            pixelDensity="default"
          />
        </div>
      )}
      <div
        className={`flex w-full pt-12 pr-8 pb-[18px] pl-16 md:py-32 md:px-24 ${
          image
            ? 'flex-col items-center lg:items-start justify-center'
            : 'flex-col lg:flex-row items-start lg:w-auto'
        }`}
      >
        {tags && tags.length > 0 && (
          <div className="flex flex-row gap-8 mb-16 flex-wrap">
            {tags.map((tag: any, i: any) => (
              <Tag {...tag} key={i}>{tag.title}</Tag>
            ))}
          </div>
        )}
        <p
          className={classNames(
            titleClassName ? titleClassName : textTitle3,
            `${image ? '' : 'flex-1'}`,
            'text-center w-full md:w-auto md:text-left block ',
            'md:pb-24',
          )}
        >
          {title}
        </p>
        {cta && (
          <div
            className={`mt-16 lg:mt-0 w-full flex justify-center lg:justify-normal`}
          >
            {cta}
          </div>
        )}
      </div>
    </div>
  );
};
